import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ChanallHomeComponent } from "../chanall-home/chanall-home.component";

import { HomeComponent } from "../home/home.component";
import { DomainHomePageComponent } from "./domain-home-page/domain-home-page.component";
import { MainHomePageComponent } from "./main-home-page/main-home-page.component";
import { PagesComponent } from "./pages.component";
import { SwigitBundleComponent } from "./swigit-bundle/swigit-bundle.component";

const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      {
        path: "donate-per-view/:apptitle",
        loadChildren: () =>
          import("./donate-per-view-route/donate-per-view-route.module").then(
            (m) => m.DonatePerViewRouteModule
          ),
      },
      {
        path: "support/:apptitle",
        loadChildren: () =>
          import("./support-route/support-route.module").then(
            (m) => m.SupportRouteModule
          ),
      },
      {
        path: "watchWithTicketCode/:apptitle",
        loadChildren: () =>
          import(
            "./watch-with-ticket-route/watch-with-ticket-route.module"
          ).then((m) => m.WatchWithTicketRouteModule),
      },
      {
        path: "liveVideoPlayer/:apptitle",
        loadChildren: () =>
          import(
            "./live-video-player-route/live-video-player-route.module"
          ).then((m) => m.LiveVideoPlayerRouteModule),
      },
      {
        path: "enterTicketCode/:apptitle",
        loadChildren: () =>
          import(
            "./enter-ticket-code-route/enter-ticket-code-route.module"
          ).then((m) => m.EnterTicketCodeRouteModule),
      },
      { path: "", component: ChanallHomeComponent },
      { path: "domain", component: DomainHomePageComponent },
      
      { path: "app", component: HomeComponent },
      { path: "sbundle", component: MainHomePageComponent },
      { path: "app/:apptitle", component: HomeComponent },
      {
        path: "myprofile",
        loadChildren: () =>
          import("./my-profile/my-profile.module").then(
            (m) => m.MyProfileModule
          ),
      },
      {
        path: "mypaymenthistory",
        loadChildren: () =>
          import("./my-payment-history/my-payment-history.module").then(
            (m) => m.MyPaymentHistoryModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
